import React from "react";

const testimonials = [
  {
    name: "Neha",
    age: 34,
    review:
      "I lost 6 kg in 2 months with Revibe’s online classes & Diet Guidance. My health is anytime better than before!",
    rating: 4.8,
  },
  {
    name: "Ramesh",
    age: 41,
    review:
      "Gyms never worked for me. Revibe made me consistent—workouts are short, fun, and the trainers push you just right.",
    rating: 4.7,
  },
  {
    name: "Aarti",
    age: 29,
    review:
      "Affordable, effective, and convenient. I work out 5 days a week now without leaving home. A lot of time and money is saved.",
    rating: 4.9,
  },
];

const Testimonials = () => {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto text-center">
        <h3 className="text-orange-500 font-semibold mb-2">Testimonials</h3>
        <h2 className="text-3xl md:text-4xl font-bold mb-12">
          Real People. Real Results.
        </h2>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md p-6 text-left hover:shadow-xl transition"
            >
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h4 className="font-semibold text-lg">{t.name}</h4>
                  <p className="text-gray-500 text-sm">{t.age} years</p>
                </div>
                <span className="bg-yellow-100 text-yellow-600 px-3 py-1 rounded-full text-sm font-medium">
                  ⭐ {t.rating}
                </span>
              </div>
              <p className="text-gray-700 leading-relaxed">{t.review}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
